var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-box home"},[_c('ul',{staticClass:"tabs"},[_c('router-link',{attrs:{"tag":"li","to":{name: 'worksList'}}},[_c('a',{attrs:{"href":"javascript:;"}},[_vm._v("作品列表")])])],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }